import React, { Suspense, lazy } from 'react'
import { Routes, Route } from 'react-router-dom'
import Login from '../views/Login'
import Main from '../views/Main'

export const useRoutes = (isAuthenticated) => {
    if (isAuthenticated) {
        return (
            <Routes>
                <Route path="/login" element={<Main></Main>}></Route>
                    <Route path="/" element={<Main></Main>}></Route>
            </Routes>
        )
    }
    return (
        <Routes>
                <Route path="/login" element={<Login></Login>}></Route>
                <Route path="/*" element={<Login></Login>}></Route>
        </Routes>
    )
}